class ProductMediaStacked extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    if (window.innerWidth >= 768) {
      this.els.media.elements[0]
        .querySelector('img.rsp-Image_Image')
        .removeAttribute('loading')
    }

    const url = new URL(window.location)
    if (url.searchParams.has('gender')) {
      this.reorderMediaBasedOfGender(url.searchParams.get('gender'))
    }

    this.els.wrapper.element.style.opacity = '1'
  }

  reorderMediaBasedOfGender (gender) {
    const media = this.els.media.elements

    const genderArray = media.filter(slide =>
      slide.querySelector('img, lazy-video').alt.includes(`[gender-${gender}]`),
    )

    if (genderArray.length > 0 && window.innerWidth >= 768) {
      genderArray[0]
        .querySelector('img.rsp-Image_Image')
        ?.removeAttribute('loading')
    }

    const theRest = media.filter(
      slide =>
        !slide
          .querySelector('img, lazy-video')
          .alt.includes(`[gender-${gender}]`),
    )

    const reorderedMedia = genderArray.concat(theRest)
    reorderedMedia.forEach(item => this.els.wrapper.element.appendChild(item))
  }
}

if (!customElements.get('')) {
  customElements.define('product-media-stacked', ProductMediaStacked)
}
